import axios from 'axios'
import {LogEntry} from './logUtils'

export type LogFilters = {
  search: string
  users: string[]
  userIds: string[]
  types: string[]
  start: string
  end: string
  hasData: 'all' | 'yes' | 'no'
  id: string
}
export type LogQuery = LogFilters & {
  page: number
  pageSize: number
  sort: 'asc' | 'desc'
  bucket: 'auto' | 'minute' | 'hour' | 'day'
}
export type LogBucket = {start: string; count: number; withData: number}
export type LogsResponse = {
  success: boolean
  data: LogEntry[]
  pagination: {
    page: number
    pageSize: number
    total: number
    totalPages: number
    hasNext: boolean
    hasPrevious: boolean
  }
  summary: {
    total: number
    users: number
    types: number
    withData: number
    firstAt: string | null
    lastAt: string | null
  }
  distribution: {
    types: Array<{id: number | null; name: string; count: number}>
    users: Array<{id: number | null; guid: string | null; name: string; count: number}>
  }
  timeline: {interval: 'minute' | 'hour' | 'day'; step?: number; buckets: LogBucket[]}
}

export const getLogs = async (query: LogQuery): Promise<LogsResponse> => {
  const {users, userIds, types, start, end, ...rest} = query
  const params = {
    ...rest,
    users: users.join(',') || undefined,
    userIds: userIds.join(',') || undefined,
    types: types.join(',') || undefined,
    start: start ? new Date(start).toISOString() : undefined,
    end: end ? new Date(end).toISOString() : undefined,
    timezoneOffset: new Date(start).getTimezoneOffset(),
    id: query.id || undefined,
  }
  const response = await axios.get('/logs', {params, __loading: false} as any)
  if (!response.data?.success)
    throw new Error(response.data?.message || 'Não foi possível consultar os registros.')
  if (!response.data.pagination || !response.data.summary || !response.data.timeline) {
    throw new Error('O serviço de logs precisa ser atualizado para disponibilizar a nova consulta.')
  }
  return response.data
}
